<template>
  <v-container fill-height fluid>

    <v-select :items="languageoptions" outlined v-model="language" @change="updateLanguage"
        style="position:fixed; right:10px; top:3px; width:100px; font-size: 18px; z-index: 999">
    </v-select>

    <h1 class="text-center" style="width: 100%;" v-if="!client_id">Neautorizovaný prístup</h1>

    <v-row class="text-center" justify="center" v-if="client_id">
      <v-col cols="12" style="max-width: 500px;">

        <v-row class="text-center" justify="center">
            <v-col cols="12" sm="12">
                <v-img
                    alt="Magio TV Logo"
                    class="ml-auto"
                    contain
                    :src="require('@/assets/logos/MAGIO_TV_magenta_white.svg')"
                    transition="scale-transition"
                    height="58"
                    style="filter: invert(0%); float: center;"
                    v-if="tenant == 'GO'"
                    />
                <v-img
                    alt="Magenta TV Logo"
                    class="ml-auto"
                    contain
                    :src="require('@/assets/logos/MAGENTA_TV_magenta_white.svg')"
                    transition="scale-transition"
                    height="58"
                    style="filter: invert(0%); float: center;"
                    v-if="tenant == 'TMCZ_GO'"
                    />
                <v-img
                    alt="DIGI Logo"
                    class="ml-auto"
                    contain
                    :src="require('@/assets/logos/digi-voyo-1.png')"
                    transition="scale-transition"
                    height="58"
                    style="filter: invert(0%); float: center;"
                    v-if="tenant == 'DIGI'"
                    />
            </v-col>
        </v-row>

        <v-row class="text-center" justify="center">
        <v-col cols="12" sm="12">
            <p class="mb-1 heading1 text-center">{{print('SSO_WEB.LOGIN_TITLE')}}</p>
            <p class="mb-3 mt-3 heading1 text-center" style="border-bottom: 1px solid rgb(255,255,255,0.3); font-size:1px;">&nbsp;</p>
            <!--p class="mb-1 heading2 text-center">{{print('PARTNER.VOYO.SSO_WEB.LOGIN_DESCRIPTION')}}</p-->
        </v-col>
        </v-row>

        <v-row justify="center" v-if="error !== ''">
            <v-col cols="12" sm="12">
                <p class="heading2 mb-0 mt-0" style="background-color: #FF00024D; color: white; border-radius: 5px; margin-top: 20px; padding: 15px 15px 15px 15px;">{{error}}</p>
            </v-col>
        </v-row>

        <v-row justify="center">
            <v-col cols="12" sm="12" class="pt-0 pb-5">
                <v-text-field clearable outlined :placeholder="print('SSO_WEB.LOGIN_USERNAME')" hide-details="auto" v-model="username" light background-color="white" color="#6C6C6C"
                    append-icon="mdi-information-outline" @click:append="$router.push({ path: '/help' })"
                    style="background-color: white;"
                    autocapitalize="off"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" sm="12" class="pt-0 pb-5">
                <v-text-field clearable outlined :placeholder="print('SSO_WEB.LOGIN_PASSWORD')" hide-details="auto" v-model="password" light background-color="white" color="#6C6C6C"
                    :append-icon="showpassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showpassword ? 'text' : 'password'" @click:append="showpassword = !showpassword"
                    autocapitalize="off"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-row justify="center" style="text-align: left;"  class="pt-0 mt-0 mb-1">
            <v-col cols="12" sm="12" class="pt-0 m-0">
                <p class="mt-1 mb-0 links"><router-link to="/help">{{print('SSO_WEB.LOGIN.HELP.USERNAME_BTN')}}</router-link></p>
                <p class="mt-1 mb-0 links"><router-link to="/resetpass">{{print('SSO_WEB.LOGIN.HELP.PASSWORD_BTN')}}</router-link></p>
            </v-col>
        </v-row>

        <v-row justify="center">
            <v-col cols="12" sm="6" class="pt-0 pb-0">
                <v-btn block x-large
                    type="submit"
                    :color="tenantColor"
                    @click="logmein"
                    :disabled="buttondisabled"
                >
                    {{print('COMMON.LOGIN')}}
                </v-btn>
            </v-col>
        </v-row>

      </v-col>
    </v-row>

  </v-container>
</template>

<style>
.heading1 {
    text-align: left;
    font-size: 30px;
    line-height: 1.2;
}
.heading2 {
    text-align: left;
    font-size: 18px;
    line-height: 1.2;
    letter-spacing: 0.7px;
}

.links a {
  color: #00A0DE !important;
  font-size: 18px
}

.links a.router-link-exact-active {
  color: #00A0DE;
}

.links a:link, a:visited {
  color: #00A0DE;
  text-decoration: none;
}

.links a:hover, a:active {
  color: #00A0DE;
  text-decoration: none;
}

.v-text-field {
    font-size: 1.5em;
    font-weight: 100;
}

.v-btn {
    text-transform: none;
    color: #EBEBEB;
    font-size: 1.5em !important;
    letter-spacing: normal;
}

</style>

<script>
  import { api } from "../main";
  import VueCookies from 'vue-cookies'
  //import HeaderComponent from '../components/HeaderComponent.vue'

  export default {
    name: 'LogIn',

    components: {
        //HeaderComponent
    },

    data: () => ({
        /*languageoptions: ['SK','EN'],*/
        language: 'SK',
        username: '',
        password: '',
        showpassword: false,
        error: '',
        client_id: '',
        redirect_uri: '',
        flow: '',
        tenant: '',
        lang: {
            'button_login': {'SK': 'Prihlásiť', 'CZ': 'Prihlásit', 'EN': 'Log In'},
            'header_login_go': {'SK': 'Prihlásenie do aplikácie Voyo pre zákazníkov Telekom', 'CZ': 'Prihlásenie pre zákazníkov Telekom', 'EN': 'Login for Telekom customers'},
            'header_login_tmcz': {'SK': 'Prihlásenie pre zákazníkov TMCZ', 'CZ': 'Prihlásenie pre zákazníkov TMCZ', 'EN': 'Login for TMCZ customers'},
            'header_login_digi': {'SK': 'Prihlásenie pre zákazníkov Digi', 'CZ': 'Prihlásenie pre zákazníkov Digi', 'EN': 'Login for Digi customers'},
        },
        //strings: {}
        buttondisabled: false
    }),

    props: ['languagestrings', 'toperror'],

    computed: {
        languageoptions() {
            if(this.tenant == 'GO' || this.tenant == 'DIGI') {
                return ['SK','EN'];
            }
            else if(this.tenant == 'TMCZ_GO') {
                return ['CZ','EN'];
            }
            else {
                return ['SK','EN'];
            }
        },
        queryParams() {
            var queryparamsarr = [];
            for (const [key, value] of Object.entries(this.$route.query)) {
                queryparamsarr.push(key + '=' + value);
            }
            return '?' + queryparamsarr.join('&');
        },
        tenantColor() {
            return this.tenant == 'DIGI' ? '#0095DA' : '#EA0A8E'; // '#0095DA'
        }
    },

    methods: {

        goBack() {
            this.$router.go(-1)
        },

        print(input_prop) {
            return api.print(this.languagestrings, input_prop);
        },

        async logmein() {
            this.buttondisabled = true;
            // SAVE LANGUAGE TO COOKIES
            VueCookies.set('language' , this.language, "1h");

            // VALIDATE INPUT
            if(!this.client_id) {
                this.error = "ERROR: missing client_id";
                this.buttondisabled = false;
                return;
            }
            if(!this.flow) {
                this.error = "ERROR: missing flow";
                this.buttondisabled = false;
                return;
            }
            if(this.flow == 'AUTHORIZATION_CODE' && !this.redirect_uri) {
                this.error = "ERROR: missing redirect_uri";
                this.buttondisabled = false;
                return;
            }
            if(!this.username || !this.password) {
                this.error = "Zadajte prosím prihlasovacie meno a heslo.";
                this.buttondisabled = false;
                return;
            }

            // CREATE POST DATA
            const data = {
                "loginOrNickname": this.username,
                "password": this.password,
                "client_id": this.client_id,
                "language": this.language
            }

            // HTTP REQUEST
            const options = {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
              },
              body: new URLSearchParams(data)
            };
            var res = await api.requestData(api.baseUrl[this.tenant] + '/oauth/internal/login', options);
            
            // REQUEST RESULTS ACTIONS
            if(Object.prototype.hasOwnProperty.call(res, 'status')) {
                if(res.status == 'ok') {
                    VueCookies.set('accessToken' , res.responseBody.accessToken, "1h");
                    this.$router.push({ path: '/allowdevice' });
                    /*
                    VueCookies.set('vopConsent' , res.responseBody.vopConsent, "1h");
                    if(res.responseBody.vopConsent == true) {
                        this.$router.push({ path: '/allowdevice' });
                        //alert("VOP Consent je sice TRUE, ale aj tak otvorim consent, aby ste videli ako consenty vyzeraju. :)");
                        //this.$router.push({ path: '/consents' });
                    }
                    else {
                        this.$router.push({ path: '/consents' });
                    }
                    */
                }
                else {
                    if(res.responseStatus == 'ECONNRESET') {
                        this.error = 'Pripojenie na server zlyhalo.';
                    }
                    else {
                        this.error = res.responseBody.error_description;
                    }              
                }
            }
            else {
                this.error = 'Pripojenie na server zlyhalo.';
            }
            this.buttondisabled = false;
        },

        updateLanguage() {
            this.$emit('updateLanguage', this.language);
        }
    },

    created: async function(){
        this.flow = this.$route.query.flow;
        this.client_id = this.$route.query.client_id;
        this.redirect_uri = this.$route.query.redirect_uri;
        this.tenant = this.$route.query.tenant;
        this.language = VueCookies.get('language');
        if(this.tenant.length > 0) {
            if(!this.language || (this.tenant == 'TMCZ_GO' && this.language == 'SK') || (this.tenant != 'TMCZ_GO' && this.language == 'CZ')) {
                if(this.tenant == 'TMCZ_GO') {
                    this.language = 'CZ';
                }
                else {
                    this.language = 'SK';
                }
            }
        }
        else {
            this.language = 'EN';
        }
        VueCookies.keys().forEach((val) => {
            if(val != 'client_id_pkce' && val!= 'client_id_nopkce') {
                VueCookies.remove(val);
            }
        });
        //console.log('query params', this.$route.query)
        for (const [key, value] of Object.entries(this.$route.query)) {
            VueCookies.set(key , value, "1h");
        }
        VueCookies.set('loginPath', this.$route.fullPath);

        if(this.toperror !== '') {
            this.error += ' ' + this.toperror;
            this.error = this.error.trim();
        }
    }
  }
</script>
